import React, { FC, useCallback } from "react"
import { useAppTemplate } from "../../../../../../Hooks/useAppTemplate"
import { APIAppInstanceModel } from "../../../../../../Models/API/AppInstanceModel"
import { hasResult } from "../../../../../../Models/Client/FetchState"
import { Loader } from "dash-styled"
import { InstanceCard } from "./InstanceCard"

interface InstanceCardViewProps {
    instance: APIAppInstanceModel
    onToggleCheck?: (item: APIAppInstanceModel) => void
    isChecked: boolean
    doOpenProject: (appID: string) => void
    doOpenProjectStatistics: (appID: string) => void
}
export const InstanceCardView: FC<InstanceCardViewProps> = ({
    instance,
    onToggleCheck,
    isChecked,
    doOpenProject,
    doOpenProjectStatistics
}) => {
    const template = useAppTemplate(
        instance.uuid,
        instance.templateName ?? undefined
    )
    const handleItemClick = useCallback(
        () => doOpenProject(instance.uuid),
        [doOpenProject, instance.uuid]
    )
    const handleStatisticsClick = useCallback(
        () => doOpenProjectStatistics(instance.uuid),
        [doOpenProjectStatistics, instance.uuid]
    )

    if (!hasResult(template)) return <Loader />

    if (template.isError) {
        return (
            <InstanceCard
                key={instance.uuid}
                instance={instance}
                errorMessage={`${template.message}`}
                onToggleCheck={onToggleCheck}
                isChecked={isChecked}
            />
        )
    }

    return (
        <InstanceCard
            key={instance.uuid}
            template={template?.value}
            instance={instance}
            onItemClick={handleItemClick}
            onStatsClick={handleStatisticsClick}
            onToggleCheck={onToggleCheck}
            isChecked={isChecked}
        />
    )
}
